import { useState } from 'react';
import { media } from 'zf-web-infra';
import { useEffectAsync } from '../../hooks';
import type { ImageItem, UseInitImageSizeResult } from './types';

/**
 * 设置图片的宽高
 * @param source
 * @returns
 */
export function useNormalize(
  source: ImageItem | ImageItem[],
  baseName?: string,
  internal?: boolean
): UseInitImageSizeResult {
  const [images, setImages] = useState<ImageItem[]>([]);

  useEffectAsync(async () => {
    const result: ImageItem[] = [];
    for (const image of Array.isArray(source) ? source : [source]) {
      result.push(await normalize(image, baseName, internal));
    }
    setImages(result);
  }, [source]);

  return { images };
}

/**
 * 设置图片高度，转换URL为oss的URL
 * @param origin
 * @returns
 */
async function normalize(origin: ImageItem, baseName?: string, internal?: boolean): Promise<ImageItem> {
  if (origin.src.length <= 0) {
    return { ...origin };
  }

  const src = media.getOssURL(origin.src, baseName, internal);
  const thumbnail = origin.thumbnail != null ? media.getOssURL(origin.thumbnail, baseName, internal) : undefined;
  if (origin.width == null && origin.type !== 'video') {
    const size = await media.getImageSize(src);
    return { ...origin, ...size, src };
  }

  return { ...origin, src, thumbnail };
}
